import React, { FC } from 'react';
import { Curve } from 'recharts';

interface ICustomShape {
  points: { x: number; y: number }[];
  stroke: string;
  strokeDasharray?: string;
  strokeWidth?: string;
}

const CustomShape: FC<ICustomShape> = ({ points, stroke, strokeDasharray = 0, strokeWidth }) => {
  const coordinates = [...points.map(({ x, y }) => ({ x, y })), { x: points[0].x, y: points[0].y }];

  return (
    <Curve
      fillOpacity="0"
      points={coordinates}
      type="natural"
      {...{ stroke, strokeDasharray, strokeWidth }}
    />
  );
};

export default CustomShape;
